import { IUserData } from "@/types";

export async function SetUsername(brand: IUserData, username: string) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/brand/settings/username",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    brand_id: brand.id,
                    old_value: brand.username,
                    username: username,
                }),
            }
        );
    } catch (error) {
        console.error("Error setting display name:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}

export async function SetDisplayName(brand: IUserData, displayname: string) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/brand/settings/display_name",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    brand_id: brand.id,
                    old_value: brand.displayname,
                    displayname: displayname,
                }),
            }
        );
    } catch (error) {
        console.error("Error setting display name:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function SetBio(brand: IUserData, bio: string) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/brand/settings/bio",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    brand_id: brand.id,
                    old_value: brand.bio,
                    bio: bio,
                }),
            }
        );
    } catch (error) {
        console.error("Error setting bio:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function SetPronouns(brand: IUserData, pronouns: string) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/brand/settings/pronouns",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    brand_id: brand.id,
                    old_value: brand.settings.pronouns,
                    pronouns: pronouns,
                }),
            }
        );
    } catch (error) {
        console.error("Error setting bio:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function SetLocation(brand: IUserData, location: string) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/brand/settings/location",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    brand_id: brand.id,
                    old_value: brand.settings.location,
                    location: location,
                }),
            }
        );
    } catch (error) {
        console.error("Error setting bio:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function SetProfilePic(brand: IUserData, file: string) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/brand/settings/profile_pic",
            {
                method: "PUT",
                headers: {
                    "Content-Type": "application/octet-stream",
                    "old-file": brand.pic,
                    "brand-id": brand.id,
                },
                body: file,
            }
        );
    } catch (error) {
        console.error("Error setting bio:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function SetShowBranding(brand: IUserData, toggle: boolean) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/brand/settings/branding_toggle",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    brand_id: brand.id,
                    old_value: brand.settings.branding,
                    toggle: toggle,
                }),
            }
        );
    } catch (error) {
        console.error("Error setting branding_toggle:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function SetDomainAdd(
    brand: IUserData,
    {
        domain,
        challenge,
    }: {
        domain: string;
        challenge: string;
    }
) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/brand/settings/domain_add",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    brand_id: brand.id,
                    domain,
                    challenge,
                    username: brand.username,
                    id: brand.id,
                }),
            }
        );
    } catch (error) {
        console.error("Error setting domain:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function BrandInvite(
    brand: IUserData,
    email: string,
    role: string
) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/brand/invite",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    brandid: brand.id,
                    email: email,
                    role: role,
                }),
            }
        );
    } catch (error) {
        console.error("Error setting domain:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function BrandUserRoleUpdate(
    brand: IUserData,
    user_id: string,
    role: string,
    status: string
) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/brand/update_user_role",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    brandid: brand.id,
                    user_id: user_id,
                    role: role,
                    status: status,
                }),
            }
        );
    } catch (error) {
        console.error("Error setting domain:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function BrandUserRemove(
    brand: IUserData,
    user_id: string,
    status: string
) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/brand/remove_user",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    brandid: brand.id,
                    user_id: user_id,
                    status: status,
                }),
            }
        );
    } catch (error) {
        console.error("Error setting domain:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function InviteAccept(brand: IUserData, user_id: string) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/brand/invite_join",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    brandid: brand.id,
                    user_id: user_id,
                }),
            }
        );
    } catch (error) {
        console.error("Error setting domain:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function InviteDecline(brand: IUserData, user_id: string) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/brand/invite_decline",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    brandid: brand.id,
                    user_id: user_id,
                }),
            }
        );
    } catch (error) {
        console.error("Error setting domain:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function CreateAccount(username: string, displayname: string) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/brand/create",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    username: username,
                    displayname: displayname,
                }),
            }
        );
    } catch (error) {
        console.error("Error creating account:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
